import React, { useState, useEffect, useContext } from 'react';
import { Box, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Avatar, Button, IconButton, TextField, MenuItem, Select, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Alert, InputAdornment, Tooltip, Drawer, Tabs, Tab, Snackbar, Checkbox } from '@mui/material';
import { PersonAdd, CalendarMonth, Schedule, Search, Edit, Delete, NavigateBefore, NavigateNext, Phone, Close, WhatsApp, Sms, History, LocationOn } from '@mui/icons-material';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { toLocalInputValue } from '../utils/dateUtils';
import { SalesforcePostCallPrompt } from '../components/salesforce';
import * as XLSX from 'xlsx';

const PS = 100;
const SC = { new:'#2196F3', 'on-hold':'#FF9800', qualified:'#9C27B0', converted:'#4CAF50', 'not-interested':'#F44336' };
const STATUS_LABELS = { new:'New', 'on-hold':'On Hold', qualified:'Qualified', converted:'Converted', 'not-interested':'Non-Interested' };
const PC = { low:'#9E9E9E', medium:'#FF9800', high:'#F44336' };
const EF = { name:'', phone:'', alternatePhone:'', email:'', source:'website', status:'new', priority:'medium', notes:'', address:'', connectedLoad:'', maxDemandValue:'' };

const NON_INTERESTED_REASONS = ['Financial condition not suitable','Solar already installed','Rooftop not suitable','Rented house','No trust in Govt schemes','Heard negative reviews regarding solar','Family not interested','Waiting for subsidy clarity','Electricity bill too low','Seasonal residence / not permanent stay','Others'];
const ON_HOLD_REASONS = ['Cash flow constraints','Decision maker not at home','Not convinced about solar system working','Price too high','Need to repair roof','Waiting for family approval','Wants to compare other vendors','Waiting for crop/business season income','Loan discussion pending','Government subsidy understanding pending','Others'];
// DO NOT CHANGE — matches master data source values
const API_SOURCES = ['website','referral','cold_call','campaign','walk_in','social_media','AMI Installation Data','solar_expo','newspaper_ad','tv_ad','radio_ad','dealer_reference','government_scheme','other'];
const API_BASE = '/api';
const token = () => localStorage.getItem('token');
const authHeader = () => ({ headers: { Authorization: 'Bearer ' + token() } });

  const logCall = async (leadId, outcome, notes = '', reason = '') => {
    try {
      await axios.post(API_BASE + '/calls', {
        lead: leadId,
        outcome,
        notes,
        reason,
        duration: 0,
        callTime: new Date().toISOString()
      }, authHeader());
    } catch (e) {
      console.log('Call log skipped:', e.message);
    }
  };


export default function PreLeads() {
  const { user } = useContext(AuthContext);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sf, setSf] = useState('');
  const [open, setOpen] = useState(false);
  const [editLead, setEditLead] = useState(null);
  const [form, setForm] = useState(EF);
  const [saving, setSaving] = useState(false);
  const [fe, setFe] = useState('');
  const [drawer, setDrawer] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [commTab, setCommTab] = useState(0);
  const [waMsg, setWaMsg] = useState('');
  const [waSending, setWaSending] = useState(false);
  const [waResult, setWaResult] = useState(null);
  const [smsMsg, setSmsMsg] = useState('');
  const [smsSending, setSmsSending] = useState(false);
  const [smsResult, setSmsResult] = useState(null);
  const [callLogs, setCallLogs] = useState([]);
  const [callLogsLoading, setCallLogsLoading] = useState(false);
  const [leadAppts, setLeadAppts] = useState([]);
  const [leadApptsLoading, setLeadApptsLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

  // Appointment scheduling
  const [apptOpen, setApptOpen] = useState(false);
  const [apptLead, setApptLead] = useState(null);
  const [apptForm, setApptForm] = useState({title:'',startTime:'',endTime:'',location:'',notes:'',status:'scheduled'});
  const [apptSaving, setApptSaving] = useState(false);
  const [apptError, setApptError] = useState('');

  // Recall scheduling
  const [recallOpen, setRecallOpen] = useState(false);
  const [recallLead, setRecallLead] = useState(null);
  const [recallForm, setRecallForm] = useState({scheduledAt:'',reason:'',priority:'medium',notes:''});
  const [recallSaving, setRecallSaving] = useState(false);
  const [recallError, setRecallError] = useState('');
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [bulkUser, setBulkUser] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const [fvSalesperson, setFvSalesperson] = useState('');
  const [fvDate, setFvDate] = useState('');
  const [fvNotes, setFvNotes] = useState('');
  const [fvSaving, setFvSaving] = useState(false);
  const [fvResult, setFvResult] = useState(null);

  const showSnack = (msg, severity='success') => setSnack({ open: true, msg, severity });
  const [sources, setSources] = useState(API_SOURCES);
  const [bulkCity, setBulkCity] = useState('');
  // SERVER_TOTAL_STATE_ADDED
  const [serverTotal, setServerTotal] = useState(0);
  const [bulkState, setBulkState] = useState('');
  const [consumptionSort, setConsumptionSort] = useState('desc');
  const [colFilters, setColFilters] = useState({state:'',city:'',source:'',priority:''});
  const [reassignOpen, setReassignOpen] = useState(false);
  const [reassignLead, setReassignLead] = useState(null);
  const [reassignUser, setReassignUser] = useState('');
  const [reassignSaving, setReassignSaving] = useState(false);
  const [bulkStatus, setBulkStatus] = useState('');
  const [sfLead, setSfLead] = useState(null); // Salesforce post-call prompt

  // Appointment state

  const loadSources = async () => {
    try {
      const r = await axios.get(API_BASE+'/master-data/sources', authHeader());
      if(r.data.sources?.length) setSources(r.data.sources);
    } catch(e) {}
  };

  const fetchLeads = async (cityQuery='') => {
    // CITY_SERVER_FILTER_PATCH_APPLIED_V2
    try {
      setLoading(true);
      let _url = API_BASE + '/leads?limit=2000&page=1';
      if (cityQuery) _url += '&city=' + encodeURIComponent(cityQuery);
      const r = await axios.get(_url, authHeader());
      // Sort by consumption descending (highest consumers first)
      if (r.data.leads) {
        r.data.leads.sort((a, b) => {
          const ca = parseFloat(a.consumption) || 0;
          const cb = parseFloat(b.consumption) || 0;
          return cb - ca;
        });
      }
      setLeads(r.data.leads || []);
      setServerTotal(r.data.total ?? (r.data.leads || []).length);
    } catch(e) { setError(e.response?.data?.message || 'Failed to load leads'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchLeads(); loadSources(); }, []);
  useEffect(() => {
    const activeCity = colFilters.city || bulkCity;
    const timer = setTimeout(() => { fetchLeads(activeCity); }, 400);
    return () => clearTimeout(timer);
  }, [colFilters.city, bulkCity]);

  useEffect(() => {
    if (user?.role === 'admin' || user?.role === 'superadmin') {
      axios.get(API_BASE + '/users/team', authHeader())
        .then(r => setUsers(r.data.users || []))
        .catch(() => {});
    }
  }, [user]);

  const fetchCallLogs = async (leadId) => {
    setCallLogsLoading(true);
    try {
      const r = await axios.get(API_BASE + '/calls?lead=' + leadId, authHeader());
      setCallLogs(r.data.calls || []);
    } catch(e) { setCallLogs([]); }
    finally { setCallLogsLoading(false); }
  };

  const fetchLeadAppointments = async (leadId) => {
    setLeadApptsLoading(true);
    try {
      const r = await axios.get(API_BASE+'/appointments?lead='+leadId, authHeader());
      setLeadAppts(r.data.appointments || []);
    } catch(e) { setLeadAppts([]); }
    finally { setLeadApptsLoading(false); }
  };

  const openDrawer = (lead) => { setSelectedLead(lead); setDrawer(true); setCommTab(0); setWaMsg(''); setSmsMsg(''); setWaResult(null); setSmsResult(null); fetchCallLogs(lead._id); };

  const sendWA = async () => {
    if (!waMsg.trim()) return;
    setWaSending(true); setWaResult(null);
    try {
      await axios.post(API_BASE + '/comms/whatsapp/send', { phone: selectedLead.phone, message: waMsg, leadId: selectedLead._id }, authHeader());
      setWaMsg(''); showSnack('WhatsApp sent!');
      setWaResult({ success: true, msg: 'Sent!' });
    } catch(e) { const msg = e.response?.data?.message || 'Failed'; setWaResult({ success: false, msg }); showSnack(msg, 'error'); }
    setWaSending(false);
  };

  const sendSMS = async () => {
    if (!smsMsg.trim()) return;
    setSmsSending(true); setSmsResult(null);
    try {
      await axios.post(API_BASE + '/comms/sms/send', { phone: selectedLead.phone, message: smsMsg }, authHeader());
      setSmsMsg(''); showSnack('SMS sent!');
      setSmsResult({ success: true, msg: 'Sent!' });
    } catch(e) { const msg = e.response?.data?.message || 'Failed'; setSmsResult({ success: false, msg }); showSnack(msg, 'error'); }
    setSmsSending(false);
  };

  const initiateCall = (lead) => { window.location.href = 'tel:' + lead.phone; };

  const filtered = leads.filter(l => {
    const q = search.toLowerCase();
    const name = (l.name || ((l.firstName||'') + ' ' + (l.lastName||'')).trim()).toLowerCase();
    const matchSearch = !q || name.includes(q) || (l.phone||'').includes(q) || (l.email||'').toLowerCase().includes(q);
    const matchStatus = !sf && !bulkStatus ? true : (sf ? l.status===sf : l.status===bulkStatus);
    const matchCity = !bulkCity ? true : (l.address||'').toLowerCase().includes(bulkCity.toLowerCase()) || (l.city||'').toLowerCase().includes(bulkCity.toLowerCase());
    const matchState = !bulkState ? true : (l.state||'').toLowerCase().includes(bulkState.toLowerCase());
    return matchSearch && matchStatus && matchCity && matchState;
  });
  const colFiltered = filtered.filter(l => {
    if (colFilters.state && !(l.state||'').toLowerCase().includes(colFilters.state.toLowerCase())) return false;
    if (colFilters.city && !(l.city||'').toLowerCase().includes(colFilters.city.toLowerCase())) return false;
    if (colFilters.source && !(l.source||'').toLowerCase().includes(colFilters.source.toLowerCase())) return false;
    if (colFilters.priority && l.priority !== colFilters.priority) return false;
    if (colFilters.assignedTo && (l.assignedTo?._id||'') !== colFilters.assignedTo) return false;
    return true;
  });
  const sortedFiltered = [...colFiltered].sort((a,b)=>{
    const ca=parseFloat(a.consumption)||0, cb=parseFloat(b.consumption)||0;
    return consumptionSort==='desc' ? cb-ca : ca-cb;
  });
  const tp = Math.ceil(sortedFiltered.length / PS) || 1;
  const rows = sortedFiltered.slice((page-1)*PS, page*PS);

  const openAdd = () => { setEditLead(null); setForm(EF); setFe(''); setOpen(true); };
  const openEdit = l => {
    const displayName = l.name || ((l.firstName||'') + ' ' + (l.lastName||'')).trim() || '';
    const matchedSource = sources.find(s=>s.toLowerCase()===String(l.source||'').toLowerCase()) || l.source || '';
    setEditLead(l); setForm({ name:displayName, phone:l.phone||'', email:l.email||'', source:matchedSource, status:l.status||'new', priority:l.priority||'medium', notes:l.notes||'', address:l.address||'', connectedLoad:l.connectedLoad||'', maxDemandValue:l.maxDemandValue||'' });
    setFe(''); setOpen(true);
  };

  const bulkUnassign = async () => {
    if (selected.length === 0) return;
    if (!window.confirm('Unassign ' + selected.length + ' leads? They will have no telecaller assigned.')) return;
    try {
      setBulkLoading(true);
      await Promise.all(selected.map(id => axios.put(API_BASE + '/leads/' + id, { assignedTo: null }, authHeader())));
      setSelected([]); setBulkUser(''); fetchLeads();
      showSnack(selected.length + ' leads unassigned successfully');
    } catch(e) { showSnack('Failed to unassign leads', 'error'); }
    finally { setBulkLoading(false); }
  };

  const openReassign = (lead) => {
    setReassignLead(lead);
    setReassignUser('');
    setReassignOpen(true);
  };

  const saveReassign = async () => {
    if (!reassignUser) return;
    try {
      setReassignSaving(true);
      await axios.put(API_BASE+'/leads/'+reassignLead._id, {assignedTo: reassignUser, status:'new'}, authHeader());
      setReassignOpen(false);
      showSnack('Lead reassigned to telecaller successfully');
      fetchLeads();
    } catch(e) { showSnack('Failed to reassign', 'error'); }
    finally { setReassignSaving(false); }
  };

  const openAppointment = async (lead) => {
    // Ensure users are loaded for salesperson dropdown
    if (!users || users.length === 0) {
      try {
        const ur = await axios.get(API_BASE + '/users/team', authHeader());
        setUsers(ur.data.users || []);
      } catch(e) {}
    }
    const now = new Date(); now.setMinutes(0,0,0);
    const end = new Date(now); end.setHours(end.getHours()+1);
    setApptLead(lead);
    // Auto-fetch location from master data
    let location = lead.address || lead.city || '';
    try {
      const md = await axios.get(API_BASE+'/master-data?phone='+lead.phone, authHeader());
      const rec = md.data.records?.[0] || md.data.data?.[0];
      if (rec) {
        location = [rec.address, rec.city, rec.state].filter(Boolean).join(', ');
      }
    } catch(e) {}
    setApptForm({title:'Solar Consultation - '+(lead.name||((lead.firstName||'')+' '+(lead.lastName||'')).trim()),startTime:now.toISOString().slice(0,16),endTime:end.toISOString().slice(0,16),location,notes:'',status:'scheduled',assignedTo:''});
    setApptError('');setApptOpen(true);
  };

  const saveAppointment = async () => {
    if(!apptForm.title||!apptForm.startTime||!apptForm.endTime) return setApptError('Title, start and end time required');
    if(!apptForm.assignedTo) return setApptError('Please assign a salesperson for this appointment');
    if(new Date(apptForm.endTime)<=new Date(apptForm.startTime)) return setApptError('End time must be after start time');
    try {
      setApptSaving(true);setApptError('');
      const apptPayload = {
        title: apptForm.title,
        lead: apptLead._id,
        startTime: apptForm.startTime,
        endTime: apptForm.endTime,
        location: apptForm.location,
        notes: apptForm.notes,
        status: 'scheduled',
        appointmentStatus: 'assigned',
        assignedSalesperson: apptForm.assignedTo,  // salesperson field
        requirement: apptForm.notes,               // telecaller remarks
        message: apptForm.notes,
      };
      await axios.post(API_BASE+'/appointments', apptPayload, authHeader());
      // Mark lead as qualified
      await axios.put(API_BASE+'/leads/'+apptLead._id, {status:'qualified'}, authHeader());
      setApptOpen(false);
      showSnack('Appointment scheduled successfully!');
      // Log as interested call
      await logCall(apptLead._id, 'interested', apptForm.notes||'Appointment booked', '');
      setSfLead({ _id: apptLead._id, name: apptLead.name || [apptLead.firstName, apptLead.lastName].filter(Boolean).join(' '), status: 'qualified' });
      fetchLeads();
    } catch(e) { setApptError(e.response?.data?.message||'Failed to create appointment'); }
    finally { setApptSaving(false); }
  };

  const openRecall = (lead) => {
    const now = new Date(); now.setHours(now.getHours()+1,0,0,0);
    setRecallLead(lead);
    setRecallForm({scheduledAt:toLocalInputValue(now),reason:'',priority:'medium',notes:'',callOutcome:'on-hold'});
    setRecallError('');setRecallOpen(true);
  };

  const saveRecall = async () => {
    if(!recallForm.scheduledAt) return setRecallError('Recall date and time is required');
    try {
      setRecallSaving(true);setRecallError('');
      await axios.post(API_BASE+'/recalls',{...recallForm,lead:recallLead._id,assignedTo:user?._id},authHeader());
      const newStatus = recallForm.callOutcome==='not-interested' ? 'not-interested' : 'on-hold';
      await axios.put(API_BASE+'/leads/'+recallLead._id,{status:newStatus, statusReason:recallForm.reason||''},authHeader());
      // Log as call record
      await logCall(recallLead._id, newStatus==='not-interested'?'not-interested':'on-hold', recallForm.notes||'', recallForm.reason||'');
      setRecallOpen(false);
      showSnack('Recall scheduled! Lead moved to Recall Queue.');
      fetchLeads();
    } catch(e) { setRecallError(e.response?.data?.message||'Failed to schedule recall'); }
    finally { setRecallSaving(false); }
  };

  const save = async () => {
    if (!form.name || !form.phone) return setFe('Name and phone required');
    try {
      setSaving(true); setFe('');
      if (editLead) await axios.put(API_BASE + '/leads/' + editLead._id, form, authHeader());
      else await axios.post(API_BASE + '/leads', form, authHeader());
      setOpen(false); fetchLeads();
    } catch(e) { setFe(e.response?.data?.message || 'Failed'); }
    finally { setSaving(false); }
  };

  const del = async id => {
    if (!window.confirm('Delete this lead?')) return;
    try { await axios.delete(API_BASE + '/leads/' + id, authHeader()); fetchLeads(); }
    catch(e) { showSnack('Delete failed', 'error'); }
  };
  const bulkDelete = async () => {
    if (selected.length === 0) return;
    if (!window.confirm('Permanently delete ' + selected.length + ' leads? This cannot be undone.')) return;
    try {
      await axios.post(API_BASE + '/leads/bulk-delete', { ids: selected }, authHeader());
      setSelected([]);
      fetchLeads();
      showSnack(selected.length + ' leads deleted');
    } catch(e) { showSnack('Bulk delete failed', 'error'); }
  };

  const assignLead = async (leadId, userId) => {
    try { await axios.put(API_BASE + '/leads/' + leadId, { assignedTo: userId || null }, authHeader()); fetchLeads(); }
    catch(e) { showSnack('Assign failed', 'error'); }
  };

  const bulkAssign = async () => {
    if (!bulkUser || selected.length === 0) return;
    setBulkLoading(true);
    try {
      await Promise.all(selected.map(id => axios.put(API_BASE + '/leads/' + id, { assignedTo: bulkUser }, authHeader())));
      setSelected([]); setBulkUser(''); fetchLeads();
      showSnack(selected.length + ' leads assigned successfully');
    } catch(e) { showSnack('Bulk assign failed', 'error'); }
    finally { setBulkLoading(false); }
  };

  const telecallers = users.filter(u => u.role === 'telecaller');
  const allRowsSelected = rows.length > 0 && rows.every(r => selected.includes(r._id));

  const pbtns = () => {
    const start = Math.max(1, Math.min(page-2, tp-4));
    const end = Math.min(tp, start+4);
    return Array.from({length: end-start+1}, (_,i) => start+i);
  };

  const getName = l => (l.name || ((l.firstName||'') + ' ' + (l.lastName||'')).trim() || '—');

  const exportRows = () => sortedFiltered.map((l,i) => ({
    'S.No': i+1,
    'Name': getName(l),
    'Phone': l.phone||'',
    'Alternate Phone': l.alternatePhone||'',
    'State': l.state||'',
    'City': l.city||'',
    'Avg Consumption (kW)': l.consumption?parseFloat(l.consumption).toFixed(2):'',
    'Source': l.source||'',
    'Status': l.status||'',
    'Priority': l.priority||'',
    'Assigned To': l.assignedTo?(l.assignedTo.name||l.assignedTo.email):'Unassigned',
  }));
  const exportXLSX = () => {
    const data = exportRows();
    if (!data.length) return showSnack('No data to export','error');
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = Object.keys(data[0]).map(k=>({wch:Math.max(k.length,15)}));
    XLSX.utils.book_append_sheet(wb, ws, 'Pre-Leads');
    XLSX.writeFile(wb, 'Pre_Leads_'+new Date().toISOString().slice(0,10)+'.xlsx');
  };
  const exportCSV = () => {
    const data = exportRows();
    if (!data.length) return showSnack('No data to export','error');
    const ws = XLSX.utils.json_to_sheet(data);
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], {type:'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'Pre_Leads_'+new Date().toISOString().slice(0,10)+'.csv';
    a.click(); URL.revokeObjectURL(url);
  };

  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" height="60vh"><CircularProgress/></Box>;

  return (
    <Box sx={{p:3}}>
      {error && <Alert severity="error" sx={{mb:2}}>{error}</Alert>}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
          <Typography variant="h5" fontWeight={700} color="#003e6f">Pre-Leads</Typography>
          <Typography variant="body2" color="text.secondary">{sortedFiltered.length} total · Page {page} of {tp}</Typography>
        </Box>
        {user?.role === 'admin' || user?.role === 'superadmin' && <Button variant="contained" startIcon={<PersonAdd/>} onClick={openAdd} sx={{bgcolor:'#003e6f','&:hover':{bgcolor:'#002a4d'},borderRadius:2}}>Add Lead</Button>}
      </Box>

      <Card elevation={0} sx={{mb:2,border:'1px solid #e8eaf0',borderRadius:2}}>
        <CardContent sx={{py:1.5,'&:last-child':{pb:1.5}}}>
          <Box display="flex" gap={1.5} alignItems="center" flexWrap="wrap">
            <TextField size="small" placeholder="Search name, phone, email..." value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}
              InputProps={{startAdornment:<InputAdornment position="start"><Search fontSize="small"/></InputAdornment>}} sx={{minWidth:280}}/>
            <FormControl size="small" sx={{minWidth:140}}><InputLabel>Status</InputLabel>
              <Select value={sf} label="Status" onChange={e=>{setSf(e.target.value);setPage(1);}}>
                <MenuItem value="">All</MenuItem>
                {Object.keys(SC).map(s=><MenuItem key={s} value={s}>{s}</MenuItem>)}
              </Select>
            </FormControl>
            {(search||sf) && <Button size="small" onClick={()=>{setSearch('');setSf('');setPage(1);}}>Clear</Button>}
            <Button size="small" variant="outlined" onClick={exportXLSX} sx={{borderColor:'#1B7A3E',color:'#1B7A3E',fontSize:11}}>Export XLSX</Button>
            <Button size="small" variant="outlined" onClick={exportCSV} sx={{borderColor:'#1565C0',color:'#1565C0',fontSize:11}}>Export CSV</Button>
            <Box ml="auto"><Chip label={serverTotal+' total leads'} size="small" sx={{bgcolor:'#003e6f20',color:'#003e6f',fontWeight:600}}/></Box>
          </Box>
        </CardContent>
      </Card>

      {(user?.role==='admin'||user?.role==='superadmin') && (
        <Box display="flex" alignItems="center" gap={1.5} mb={1.5} p={1.5} sx={{bgcolor:'#f0f4ff',borderRadius:2,border:'1px solid #e0e7ff',flexWrap:'wrap'}}>
          <Typography variant="body2" fontWeight={600} color="#2196F3" sx={{minWidth:150}}>
            {selected.length > 0 ? selected.length + ' selected' : 'Bulk Reassign to Telecaller'}
          </Typography>
          <FormControl size="small" sx={{minWidth:140}}>
            <Select displayEmpty value={bulkStatus} onChange={e=>setBulkStatus(e.target.value)}
              renderValue={v=>v||<span style={{color:'#aaa'}}>Filter by status...</span>}>
              <MenuItem value="">All Status</MenuItem>
              {Object.entries(STATUS_LABELS).map(([v,l])=><MenuItem key={v} value={v}>{l}</MenuItem>)}
            </Select>
          </FormControl>
          <Select size="small" displayEmpty value={reassignUser} onChange={e=>setReassignUser(e.target.value)}
            sx={{minWidth:200,height:32,fontSize:12}}
            renderValue={v=>{ const u=users.find(x=>x._id===v); return u ? u.name : <span style={{color:'#aaa'}}>Select telecaller...</span>; }}>
            <MenuItem value=""><em>Select telecaller</em></MenuItem>
            {users.filter(u=>u.role==='telecaller').map(u=><MenuItem key={u._id} value={u._id} style={{fontSize:12}}>{u.name||u.email}</MenuItem>)}
          </Select>
          <Button size="small" variant="outlined" onClick={()=>setSelected(filtered.map(l=>l._id))}
            sx={{borderColor:'#2196F3',color:'#2196F3',fontSize:11,height:32}}>
            Select All {filtered.length}
          </Button>
          <Button size="small" variant="contained" disabled={!reassignUser||selected.length===0||reassignSaving}
            onClick={async()=>{
              setReassignSaving(true);
              try {
                await Promise.all(selected.map(id=>axios.put(API_BASE+'/leads/'+id,{assignedTo:reassignUser,status:'new'},authHeader())));
                setSelected([]); setReassignUser(''); fetchLeads();
                showSnack(selected.length+' leads reassigned to telecaller');
              } catch(e){showSnack('Failed','error');}
              finally{setReassignSaving(false);}
            }}
            sx={{bgcolor:'#2196F3','&:hover':{bgcolor:'#1565C0'},height:32,fontSize:11}}>
            {reassignSaving?'Reassigning...':'Reassign '+selected.length+' Leads'}
          </Button>
          {selected.length>0&&<Button size="small" onClick={()=>setSelected([])} sx={{color:'#666',fontSize:11}}>Clear</Button>}
        </Box>
      )}
      {user?.role==='admin' && (
        <Box display="flex" alignItems="center" gap={1.5} mb={1.5} p={1.5} sx={{bgcolor:'#f0f4ff',borderRadius:2,border:'1px solid #e0e7ff',flexWrap:'wrap'}}>
          <Typography variant="body2" fontWeight={600} color="#003e6f" sx={{minWidth:130}}>
            {selected.length > 0 ? selected.length + ' selected' : 'Bulk Assign Leads'}
          </Typography>
          <TextField size="small" placeholder="Filter by state..." value={bulkState} onChange={e=>{setBulkState(e.target.value);}} sx={{minWidth:130}}/>
          <TextField size="small" placeholder="Filter by city..." value={bulkCity} onChange={e=>{setBulkCity(e.target.value);}} sx={{minWidth:130}}/>
          <FormControl size="small" sx={{minWidth:140}}>
            <Select displayEmpty value={bulkStatus} onChange={e=>setBulkStatus(e.target.value)}
              renderValue={v=>v||<span style={{color:'#aaa'}}>Filter by status...</span>}>
              <MenuItem value="">All Status</MenuItem>
              {Object.entries(STATUS_LABELS).map(([v,l])=><MenuItem key={v} value={v}>{l}</MenuItem>)}
            </Select>
          </FormControl>
          <Select size="small" displayEmpty value={bulkUser} onChange={e=>setBulkUser(e.target.value)}
            sx={{minWidth:200,height:32,fontSize:12}}
            renderValue={v=>{ const u=users.find(x=>x._id===v); return u ? u.name : <span style={{color:'#aaa'}}>Select telecaller...</span>; }}>
            <MenuItem value=""><em>Select user</em></MenuItem>
            {telecallers.map(u=><MenuItem key={u._id} value={u._id} style={{fontSize:12}}>{u.name} ({u.role})</MenuItem>)}
          </Select>
          <Button size="small" variant="contained" disabled={!bulkUser||selected.length===0||bulkLoading} onClick={bulkAssign}
            sx={{bgcolor:'#E8622A','&:hover':{bgcolor:'#c8501f'},height:32,fontSize:11}}>
            {bulkLoading ? 'Assigning...' : 'Assign ' + (selected.length||'') + ' Leads'}
          </Button>
          <Button size="small" variant="outlined" disabled={selected.length===0||bulkLoading} onClick={bulkUnassign}
            sx={{borderColor:'#F44336',color:'#F44336','&:hover':{bgcolor:'#fff0f0'},height:32,fontSize:11}}>
            Unassign {selected.length||''} Leads
          </Button>
          <Button size="small" variant="outlined" onClick={()=>setSelected(filtered.map(l=>l._id))}
            sx={{borderColor:'#003e6f',color:'#003e6f',fontSize:11,minWidth:120}}>
            Select All {filtered.length} Filtered
          </Button>
          <Button size="small" variant="contained" disabled={selected.length===0||bulkLoading} onClick={bulkDelete}
            sx={{bgcolor:'#F44336','&:hover':{bgcolor:'#c62828'},height:32,fontSize:11}}>
            Delete {selected.length||''} Leads
          </Button>
          {selected.length>0 && <Button size="small" onClick={()=>setSelected([])} sx={{color:'#666',fontSize:11}}>Clear ({selected.length})</Button>}
        </Box>
      )}

      <TableContainer component={Paper} elevation={1} sx={{borderRadius:2}}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{'& th':{bgcolor:'#F5F7FA',fontWeight:600,fontSize:12,color:'#555',py:1.5}}}>
              {user?.role==='admin' && <TableCell padding="checkbox"><Checkbox size="small" checked={allRowsSelected} onChange={e=>{ if(e.target.checked) setSelected(s=>[...new Set([...s,...rows.map(r=>r._id)])]); else setSelected(s=>s.filter(id=>!rows.map(r=>r._id).includes(id))); }}/></TableCell>}
              <TableCell width={40}>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Alt Phone</TableCell>
              <TableCell>State</TableCell>
              <TableCell>City</TableCell>
              <TableCell sx={{cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}} onClick={()=>setConsumptionSort(s=>s==='desc'?'asc':'desc')}>Avg Consumption {consumptionSort==='desc'?'↓':'↑'}</TableCell>
              <TableCell>Source</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Priority</TableCell>
              {(user?.role==='admin'||user?.role==='superadmin') && <TableCell>Assigned To</TableCell>}
              <TableCell>Actions</TableCell>
            </TableRow>
            <TableRow sx={{'& td,& th':{py:0.5,bgcolor:'#EBF3FB'}}}>
              <TableCell/><TableCell/><TableCell/><TableCell/><TableCell/>
              <TableCell>
                <input placeholder="Filter state..." value={colFilters.state}
                  onChange={e=>setColFilters(f=>({...f,state:e.target.value}))}
                  style={{width:'100%',fontSize:11,border:'1px solid #D0DFF0',borderRadius:4,padding:'2px 6px'}}/>
              </TableCell>
              <TableCell>
                <input placeholder="Filter city..." value={colFilters.city}
                  onChange={e=>setColFilters(f=>({...f,city:e.target.value}))}
                  style={{width:'100%',fontSize:11,border:'1px solid #D0DFF0',borderRadius:4,padding:'2px 6px'}}/>
              </TableCell>
              <TableCell/>
              <TableCell>
                <input placeholder="Filter source..." value={colFilters.source}
                  onChange={e=>setColFilters(f=>({...f,source:e.target.value}))}
                  style={{width:'100%',fontSize:11,border:'1px solid #D0DFF0',borderRadius:4,padding:'2px 6px'}}/>
              </TableCell>
              <TableCell/>
              <TableCell>
                <select value={colFilters.priority} onChange={e=>setColFilters(f=>({...f,priority:e.target.value}))}
                  style={{width:'100%',fontSize:11,border:'1px solid #D0DFF0',borderRadius:4,padding:'2px 4px'}}>
                  <option value="">All</option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </TableCell>
              <TableCell>
                {(user?.role==='admin'||user?.role==='superadmin') && (
                  <select value={colFilters.assignedTo} onChange={e=>setColFilters(f=>({...f,assignedTo:e.target.value}))}
                    style={{width:'100%',fontSize:11,border:'1px solid #D0DFF0',borderRadius:4,padding:'2px 4px'}}>
                    <option value="">All</option>
                    {telecallers.map(u=><option key={u._id} value={u._id}>{u.name||u.email}</option>)}
                  </select>
                )}
              </TableCell>
              <TableCell/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length===0
              ? <TableRow><TableCell colSpan={12} align="center" sx={{py:5,color:'text.secondary'}}>No leads found</TableCell></TableRow>
              : rows.map((l,i) => (
                <TableRow key={l._id} hover sx={{'&:hover':{bgcolor:'#F0F4FF'},cursor:'pointer'}} onClick={()=>openDrawer(l)}>
                  {user?.role==='admin' && <TableCell padding="checkbox" onClick={e=>e.stopPropagation()}>
                    <Checkbox size="small" checked={selected.includes(l._id)} onChange={e=>{ e.stopPropagation(); setSelected(s=>e.target.checked?[...s,l._id]:s.filter(x=>x!==l._id)); }}/>
                  </TableCell>}
                  <TableCell sx={{color:'#999',fontSize:11}}>{(page-1)*PS+i+1}</TableCell>
                  <TableCell><Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{width:26,height:26,fontSize:11,bgcolor:'#003e6f15',color:'#003e6f',fontWeight:700}}>{getName(l).charAt(0).toUpperCase()}</Avatar>
                    <Typography variant="body2" fontWeight={500} sx={{fontSize:13}}>{getName(l)}</Typography>
                  </Box></TableCell>
                  <TableCell sx={{fontSize:13,fontFamily:'monospace'}}>{l.phone}</TableCell>
                  <TableCell sx={{fontSize:13,fontFamily:'monospace',color:'#888'}}>{l.alternatePhone||'-'}</TableCell>
                  <TableCell sx={{fontSize:12}}>{l.state||'-'}</TableCell>
                  <TableCell sx={{fontSize:12}}>{l.city || l.address?.split(',').pop()?.trim()||'-'}</TableCell>
                  <TableCell sx={{fontSize:12,fontWeight:500,color:'#1565C0'}}>{l.consumption ? parseFloat(l.consumption).toFixed(2)+' kW' : '-'}</TableCell>
                  <TableCell><Chip label={l.source?.replace(/_/g,' ')} size="small" variant="outlined" sx={{fontSize:10,height:20}}/></TableCell>
                  <TableCell><Chip label={STATUS_LABELS[l.status]||l.status} size="small" sx={{bgcolor:(SC[l.status]||'#9E9E9E')+'18',color:SC[l.status]||'#9E9E9E',fontWeight:600,fontSize:10,height:20}}/></TableCell>
                  <TableCell><Chip label={l.priority} size="small" sx={{bgcolor:PC[l.priority]+'18',color:PC[l.priority],fontSize:10,height:20}}/></TableCell>
                  {user?.role==='admin' && <TableCell onClick={e=>e.stopPropagation()} sx={{minWidth:150}}>
                    <Select size="small" displayEmpty value={l.assignedTo?._id||l.assignedTo||''}
                      onChange={e=>assignLead(l._id, e.target.value)}
                      sx={{fontSize:11,minWidth:140,height:28}}
                      renderValue={v=>{ const u=users.find(x=>x._id===v); return u ? <span style={{fontSize:11}}>{u.name}</span> : <span style={{color:'#aaa',fontSize:11}}>Unassigned</span>; }}>
                      <MenuItem value=""><em style={{fontSize:11}}>Unassigned</em></MenuItem>
                      {telecallers.map(u=><MenuItem key={u._id} value={u._id} style={{fontSize:11}}>{u.name}</MenuItem>)}
                    </Select>
                  </TableCell>}
                  <TableCell onClick={e=>e.stopPropagation()}>
                    <Box display="flex" gap={0.5}>
                      <Tooltip title="Call"><IconButton size="small" onClick={()=>initiateCall(l)} sx={{color:'white',bgcolor:'#22c55e','&:hover':{bgcolor:'#16a34a'},width:28,height:28,borderRadius:1}}><Phone sx={{fontSize:14}}/></IconButton></Tooltip>
                      <Tooltip title="Schedule Appointment"><IconButton size="small" onClick={()=>openAppointment(l)} sx={{color:'#9C27B0'}}><CalendarMonth sx={{fontSize:15}}/></IconButton></Tooltip>
                      {(user?.role==='admin'||user?.role==='superadmin') && <Tooltip title="Reassign to Telecaller"><IconButton size="small" onClick={e=>{e.stopPropagation();openReassign(l);}} sx={{color:'#2196F3'}}><PersonAdd sx={{fontSize:15}}/></IconButton></Tooltip>}
                      <Tooltip title="Set Recall"><IconButton size="small" onClick={e=>{e.stopPropagation();openRecall(l);}} sx={{color:'#FF9800'}}><Schedule sx={{fontSize:15}}/></IconButton></Tooltip>
                      <Tooltip title="Edit"><IconButton size="small" onClick={e=>{e.stopPropagation();openEdit(l);}} sx={{color:'#2196F3'}}><Edit sx={{fontSize:15}}/></IconButton></Tooltip>
                      {user?.role==='admin' && <Tooltip title="Delete"><IconButton size="small" onClick={e=>{e.stopPropagation();del(l._id);}} sx={{color:'#F44336'}}><Delete sx={{fontSize:15}}/></IconButton></Tooltip>}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} flexWrap="wrap" gap={1}>
        <Typography variant="body2" color="text.secondary">
          Showing {rows.length>0?(page-1)*PS+1:0}–{Math.min(page*PS,filtered.length)} of {filtered.length}
        </Typography>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Button size="small" variant="outlined" disabled={page===1} onClick={()=>setPage(p=>p-1)} startIcon={<NavigateBefore/>}
            sx={{minWidth:80,borderColor:'#003e6f',color:'#003e6f','&:hover':{bgcolor:'#003e6f10'},'&:disabled':{borderColor:'#ddd',color:'#ddd'}}}>Prev</Button>
          {pbtns().map(p=>(
            <Button key={p} size="small" onClick={()=>setPage(p)}
              sx={{minWidth:32,height:32,p:0,borderRadius:1,bgcolor:page===p?'#003e6f':'transparent',color:page===p?'white':'#666','&:hover':{bgcolor:page===p?'#002a4d':'#f5f5f5'}}}>{p}</Button>
          ))}
          <Button size="small" variant="outlined" disabled={page===tp} onClick={()=>setPage(p=>p+1)} endIcon={<NavigateNext/>}
            sx={{minWidth:80,borderColor:'#003e6f',color:'#003e6f','&:hover':{bgcolor:'#003e6f10'},'&:disabled':{borderColor:'#ddd',color:'#ddd'}}}>Next</Button>
        </Box>
      </Box>

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={()=>setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editLead?'Edit Lead':'Add New Lead'}</DialogTitle>
        <DialogContent>
          {fe && <Alert severity="error" sx={{mb:2}}>{fe}</Alert>}
          <Box sx={{display:'flex',flexDirection:'column',gap:2,mt:1}}>
            <TextField label="Full Name *" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} size="small" fullWidth/>
            <TextField label="Phone *" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} size="small" fullWidth/>
            <TextField label="Alternate Phone" value={form.alternatePhone||''} onChange={e=>setForm({...form,alternatePhone:e.target.value})} size="small" fullWidth/>
            <TextField label="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} size="small" fullWidth/>
            <TextField label="Address / City" value={form.address} onChange={e=>setForm({...form,address:e.target.value})} size="small" fullWidth/>
            <FormControl size="small" fullWidth><InputLabel>Source</InputLabel>
              <Select value={form.source} label="Source" onChange={e=>setForm({...form,source:e.target.value})}>
                {sources.map(s=><MenuItem key={s} value={s}>{s}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" fullWidth><InputLabel>Status</InputLabel>
              <Select value={form.status} label="Status" onChange={e=>setForm({...form,status:e.target.value})}>
                {Object.entries(STATUS_LABELS)
                  .filter(([v]) => (user?.role==='admin'||user?.role==='superadmin')
                    ? true  // admin sees all
                    : ['new','on-hold','not-interested'].includes(v)  // telecaller only sees these
                  )
                  .map(([v,l])=><MenuItem key={v} value={v}>{l}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl size="small" fullWidth><InputLabel>Priority</InputLabel>
              <Select value={form.priority} label="Priority" onChange={e=>setForm({...form,priority:e.target.value})}>
                {['low','medium','high'].map(p=><MenuItem key={p} value={p}>{p}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField label="Notes" value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} size="small" fullWidth multiline rows={2}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={save} disabled={saving} sx={{bgcolor:'#003e6f'}}>{saving?'Saving...':'Save'}</Button>
        </DialogActions>
      </Dialog>

      {/* Communication Drawer */}
      <Drawer anchor="right" open={drawer} onClose={()=>setDrawer(false)} PaperProps={{sx:{width:400}}}>
        {selectedLead && (
          <Box sx={{p:3,height:'100%',overflow:'auto'}}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6" fontWeight={700}>{getName(selectedLead)}</Typography>
              <IconButton onClick={()=>setDrawer(false)}><Close/></IconButton>
            </Box>
            <Box mb={2}>
              <Typography variant="body2" color="text.secondary">{selectedLead.phone}</Typography>
              <Typography variant="body2" color="text.secondary">{selectedLead.email}</Typography>
            </Box>
            <Tabs value={commTab} onChange={(_,v)=>setCommTab(v)} sx={{mb:2}}>
              <Tab icon={<WhatsApp/>} label="WhatsApp" sx={{minWidth:80,fontSize:11}}/>
              <Tab icon={<Sms/>} label="SMS" sx={{minWidth:80,fontSize:11}}/>
              <Tab icon={<History/>} label="Call Logs" sx={{minWidth:80,fontSize:11}}/>
              <Tab icon={<LocationOn/>} label="Field Visit" sx={{minWidth:80,fontSize:11}}/>
            </Tabs>
            {commTab===0 && (
              <Box>
                <TextField fullWidth multiline rows={4} placeholder="Type WhatsApp message..." value={waMsg} onChange={e=>setWaMsg(e.target.value)} size="small" sx={{mb:1}}/>
                {waResult && <Alert severity={waResult.success?'success':'error'} sx={{mb:1}}>{waResult.msg}</Alert>}
                <Button fullWidth variant="contained" startIcon={<WhatsApp/>} onClick={sendWA} disabled={waSending||!waMsg.trim()} sx={{bgcolor:'#25D366','&:hover':{bgcolor:'#1da851'}}}>
                  {waSending?'Sending...':'Send WhatsApp'}
                </Button>
              </Box>
            )}
            {commTab===1 && (
              <Box>
                <TextField fullWidth multiline rows={4} placeholder="Type SMS message..." value={smsMsg} onChange={e=>setSmsMsg(e.target.value)} size="small" sx={{mb:1}}/>
                {smsResult && <Alert severity={smsResult.success?'success':'error'} sx={{mb:1}}>{smsResult.msg}</Alert>}
                <Button fullWidth variant="contained" startIcon={<Sms/>} onClick={sendSMS} disabled={smsSending||!smsMsg.trim()} sx={{bgcolor:'#2196F3'}}>
                  {smsSending?'Sending...':'Send SMS'}
                </Button>
              </Box>
            )}
            {commTab===2 && (
              <Box>
                {callLogsLoading ? <CircularProgress size={24}/> : callLogs.length===0 ? <Typography color="text.secondary" variant="body2">No call logs yet.</Typography> :
                  callLogs.map(c=>(
                    <Box key={c._id} sx={{p:1.5,mb:1,bgcolor:'#f5f7fa',borderRadius:1}}>
                      <Typography variant="body2" fontWeight={600}>{c.direction} — {c.duration}s</Typography>
                      <Typography variant="caption" color="text.secondary">{new Date(c.createdAt).toLocaleString()}</Typography>
                    </Box>
                  ))
                }
              </Box>
            )}
            {commTab===3 && (
              <Box>
                <Typography variant="body2" fontWeight={600} color="#003e6f" mb={2}>
                  Assign Field Visit to Salesperson
                </Typography>
                <Box display="flex" flexDirection="column" gap={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Select Salesperson *</InputLabel>
                    <Select value={fvSalesperson} label="Select Salesperson *" onChange={e=>setFvSalesperson(e.target.value)}>
                      <MenuItem value=""><em>Select...</em></MenuItem>
                      {users.filter(u=>u.role==='salesperson').map(u=><MenuItem key={u._id} value={u._id}>{u.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                  <TextField fullWidth size="small" label="Visit Date & Time *" type="datetime-local"
                    value={fvDate} onChange={e=>setFvDate(e.target.value)} InputLabelProps={{shrink:true}}/>
                  <TextField fullWidth size="small" label="Notes / Instructions" multiline rows={3}
                    value={fvNotes} onChange={e=>setFvNotes(e.target.value)} placeholder="e.g. Customer interested in 5kW rooftop solar..."/>
                  {fvResult && <Alert severity={fvResult.success?'success':'error'}>{fvResult.msg}</Alert>}
                  <Button fullWidth variant="contained" startIcon={<LocationOn/>} disabled={!fvSalesperson||!fvDate||fvSaving}
                    onClick={async()=>{
                      setFvSaving(true); setFvResult(null);
                      try {
                        const endTime = new Date(new Date(fvDate).getTime() + 60*60*1000).toISOString().slice(0,16);
                        await axios.post(API_BASE+'/appointments', {
                          title: 'Field Visit — ' + getName(selectedLead),
                          lead: selectedLead._id,
                          assignedTo: fvSalesperson,
                          startTime: fvDate,
                          endTime: endTime,
                          status: 'scheduled',
                          notes: fvNotes || 'Field visit assigned by telecaller ' + (user?.name||''),
                          location: selectedLead.address || selectedLead.city || ''
                        }, authHeader());
                        setFvResult({ success: true, msg: 'Field visit assigned successfully!' });
                        setFvSalesperson(''); setFvDate(''); setFvNotes('');
                        showSnack('Field visit assigned!');
                      } catch(e) {
                        setFvResult({ success: false, msg: e.response?.data?.message || 'Failed to assign field visit' });
                      }
                      setFvSaving(false);
                    }}
                    sx={{bgcolor:'#003e6f','&:hover':{bgcolor:'#002a4d'}}}>
                    {fvSaving ? 'Assigning...' : 'Assign Field Visit'}
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        )}
      </Drawer>

      <Snackbar open={snack.open} autoHideDuration={3000} onClose={()=>setSnack({...snack,open:false})} anchorOrigin={{vertical:'bottom',horizontal:'center'}}>
        <Alert severity={snack.severity} onClose={()=>setSnack({...snack,open:false})}>{snack.msg}</Alert>
      </Snackbar>

      {/* Reassign Lead Dialog */}
      <Dialog open={reassignOpen} onClose={()=>setReassignOpen(false)} maxWidth="xs" fullWidth PaperProps={{sx:{borderRadius:3}}}>
        <DialogTitle fontWeight={700} sx={{display:'flex',alignItems:'center',gap:1}}>
          <PersonAdd sx={{color:'#2196F3'}}/> Reassign Lead to Telecaller
          {reassignLead&&<Typography variant="caption" sx={{ml:1,color:'text.secondary'}}>— {reassignLead.name}</Typography>}
        </DialogTitle>
        <DialogContent>
          <Box mt={1}>
            <FormControl fullWidth size="small"><InputLabel>Select Telecaller</InputLabel>
              <Select value={reassignUser} label="Select Telecaller" onChange={e=>setReassignUser(e.target.value)}>
                {users.filter(u=>u.role==='telecaller').map(u=><MenuItem key={u._id} value={u._id}>{u.name||u.email}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button onClick={()=>setReassignOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveReassign} disabled={reassignSaving||!reassignUser}
            sx={{bgcolor:'#2196F3','&:hover':{bgcolor:'#1565C0'},borderRadius:2,px:3}}>
            {reassignSaving?<CircularProgress size={18} sx={{color:'white'}}/>:'Reassign'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reassign Lead Dialog */}
      <Dialog open={reassignOpen} onClose={()=>setReassignOpen(false)} maxWidth="xs" fullWidth PaperProps={{sx:{borderRadius:3}}}>
        <DialogTitle fontWeight={700} sx={{display:'flex',alignItems:'center',gap:1}}>
          <PersonAdd sx={{color:'#2196F3'}}/> Reassign Lead to Telecaller
          {reassignLead&&<Typography variant="caption" sx={{ml:1,color:'text.secondary'}}>— {reassignLead.name}</Typography>}
        </DialogTitle>
        <DialogContent>
          <Box mt={1}>
            <FormControl fullWidth size="small"><InputLabel>Select Telecaller</InputLabel>
              <Select value={reassignUser} label="Select Telecaller" onChange={e=>setReassignUser(e.target.value)}>
                {users.filter(u=>u.role==='telecaller').map(u=><MenuItem key={u._id} value={u._id}>{u.name||u.email}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button onClick={()=>setReassignOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveReassign} disabled={reassignSaving||!reassignUser}
            sx={{bgcolor:'#2196F3','&:hover':{bgcolor:'#1565C0'},borderRadius:2,px:3}}>
            {reassignSaving?<CircularProgress size={18} sx={{color:'white'}}/>:'Reassign'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Schedule Appointment Dialog */}
      <Dialog open={apptOpen} onClose={()=>setApptOpen(false)} maxWidth="sm" fullWidth PaperProps={{sx:{borderRadius:3}}}>
        <DialogTitle fontWeight={700} sx={{display:'flex',alignItems:'center',gap:1}}>
          <CalendarMonth sx={{color:'#9C27B0'}}/> Schedule Appointment
          {apptLead&&<Typography variant="caption" sx={{ml:1,color:'text.secondary'}}>for {apptLead.name||((apptLead.firstName||'')+' '+(apptLead.lastName||'')).trim()}</Typography>}
        </DialogTitle>
        <DialogContent>
          {apptError&&<Alert severity="error" sx={{mb:2,mt:1}}>{apptError}</Alert>}
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField fullWidth label="Title *" value={apptForm.title} onChange={e=>setApptForm({...apptForm,title:e.target.value})} size="small"/>
            <Box display="flex" gap={2}>
              <TextField fullWidth label="Start Time *" type="datetime-local" value={apptForm.startTime} onChange={e=>setApptForm({...apptForm,startTime:e.target.value})} size="small" InputLabelProps={{shrink:true}}/>
              <TextField fullWidth label="End Time *" type="datetime-local" value={apptForm.endTime} onChange={e=>setApptForm({...apptForm,endTime:e.target.value})} size="small" InputLabelProps={{shrink:true}}/>
            </Box>
            <TextField fullWidth label="Location" value={apptForm.location} onChange={e=>setApptForm({...apptForm,location:e.target.value})} size="small" placeholder="Customer site, office, video call..."/>
            <TextField fullWidth label="Notes" value={apptForm.notes} onChange={e=>setApptForm({...apptForm,notes:e.target.value})} size="small" multiline rows={2}/>
            <FormControl size="small" fullWidth>
              <InputLabel>Assign to Salesperson *</InputLabel>
              <Select value={apptForm.assignedTo||''} label="Assign to Salesperson *" onChange={e=>setApptForm({...apptForm,assignedTo:e.target.value})}>

                {users.filter(u=>u.role==='salesperson').map(u=><MenuItem key={u._id} value={u._id}>{u.name||u.email}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button onClick={()=>setApptOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveAppointment} disabled={apptSaving} sx={{bgcolor:'#9C27B0','&:hover':{bgcolor:'#7B1FA2'},borderRadius:2,px:3}}>
            {apptSaving?<CircularProgress size={18} sx={{color:'white'}}/>:'Schedule'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Set Recall Dialog */}
      <Dialog open={recallOpen} onClose={()=>setRecallOpen(false)} maxWidth="xs" fullWidth PaperProps={{sx:{borderRadius:3}}}>
        <DialogTitle fontWeight={700} sx={{display:'flex',alignItems:'center',gap:1}}>
          <Schedule sx={{color:'#FF9800'}}/> Set Recall Time
          {recallLead&&<Typography variant="caption" sx={{ml:1,color:'text.secondary'}}>for {recallLead.name||((recallLead.firstName||'')+' '+(recallLead.lastName||'')).trim()}</Typography>}
        </DialogTitle>
        <DialogContent>
          {recallError&&<Alert severity="error" sx={{mb:2,mt:1}}>{recallError}</Alert>}
          <FormControl size="small" fullWidth sx={{mb:2,mt:1}}>
            <InputLabel>Call Outcome *</InputLabel>
            <Select value={recallForm.callOutcome||'on-hold'} label="Call Outcome *" onChange={e=>setRecallForm({...recallForm,callOutcome:e.target.value,reason:''})}>
              <MenuItem value="on-hold">On Hold</MenuItem>
              <MenuItem value="not-interested">Non-Interested</MenuItem>
            </Select>
          </FormControl>
          {recallForm.callOutcome==='not-interested' &&
            <FormControl size="small" fullWidth sx={{mb:2}}>
              <InputLabel>Non-Interested Reason *</InputLabel>
              <Select value={recallForm.reason||''} label="Non-Interested Reason *" onChange={e=>setRecallForm({...recallForm,reason:e.target.value})}>
                {NON_INTERESTED_REASONS.map(r=><MenuItem key={r} value={r}>{r}</MenuItem>)}
              </Select>
            </FormControl>
          }
          {(recallForm.callOutcome==='on-hold'||!recallForm.callOutcome) &&
            <FormControl size="small" fullWidth sx={{mb:2}}>
              <InputLabel>On Hold Reason *</InputLabel>
              <Select value={recallForm.reason||''} label="On Hold Reason *" onChange={e=>setRecallForm({...recallForm,reason:e.target.value})}>
                {ON_HOLD_REASONS.map(r=><MenuItem key={r} value={r}>{r}</MenuItem>)}
              </Select>
            </FormControl>
          }
          <Alert severity="info" sx={{mb:1,fontSize:12}}>Lead status will be updated and added to Recall Queue.</Alert>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField fullWidth label="Recall Date & Time *" type="datetime-local" value={recallForm.scheduledAt} onChange={e=>setRecallForm({...recallForm,scheduledAt:e.target.value})} size="small" InputLabelProps={{shrink:true}}/>

            <FormControl fullWidth size="small"><InputLabel>Priority</InputLabel>
              <Select value={recallForm.priority} label="Priority" onChange={e=>setRecallForm({...recallForm,priority:e.target.value})}>
                {['low','medium','high'].map(p=><MenuItem key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField fullWidth label="Notes" value={recallForm.notes} onChange={e=>setRecallForm({...recallForm,notes:e.target.value})} size="small" multiline rows={2}/>
          </Box>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button onClick={()=>setRecallOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveRecall} disabled={recallSaving} sx={{bgcolor:'#FF9800','&:hover':{bgcolor:'#F57C00'},borderRadius:2,px:3}}>
            {recallSaving?<CircularProgress size={18} sx={{color:'white'}}/>:'Set Recall'}
          </Button>
        </DialogActions>
      </Dialog>
      <SalesforcePostCallPrompt lead={sfLead} onChange={setSfLead} onClose={() => setSfLead(null)} />
    </Box>
  );
}
